import { forwardRef } from 'preact/compat'

export const SearchInput = forwardRef(({ onInput, redirect }, ref) => {
  return (
    <input
      ref={ref}
      onInput={onInput}
      className="field-input grow w-full h6 p-0 border-0 focus:border-0 text-ellipsis"
      type="text"
      name="query"
      placeholder="Search by style, material, colour..."
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          if (redirect) {
            window.location.href = redirect
          } else {
            window.location.href = `/search?query=${e.target.value}`
          }
        }
      }}
    />
  )
})
